import {
  AfterViewInit,
  Component,
  HostBinding,
  Input,
  OnInit,
  TemplateRef,
  ViewChild,
  inject
} from '@angular/core';
import { FilteringLogic, IgxStringFilteringOperand } from '@infragistics/igniteui-angular/core';
import {
  IGridEditDoneEventArgs, IGridEditEventArgs, IgxColumnComponent, IgxExcelExporterService, IgxPdfExporterService,
  IgxGridCell, IgxGridStateDirective, RowType
} from '@infragistics/igniteui-angular/grids/core';
import { IGX_GRID_DIRECTIVES, IgxGridComponent, IgxGridModule } from '@infragistics/igniteui-angular/grids/grid';
import { IgxIconComponent } from '@infragistics/igniteui-angular/icon';
import { IgxButtonDirective, IgxButtonModule, IgxFocusDirective, IgxRippleDirective, IgxRippleModule, IgxTextSelectionDirective } from '@infragistics/igniteui-angular/directives';
import {
  IGX_INPUT_GROUP_DIRECTIVES,
  IgxInputGroupComponent,
  IgxSuffixDirective
} from '@infragistics/igniteui-angular/input-group';
import { IGX_ACTION_STRIP_DIRECTIVES, IgxActionStripModule } from '@infragistics/igniteui-angular/action-strip';
import {ClsConfig} from '../../../util/cls-config';
import {MasOpcionesGridComponent} from '../../util/controles/mas-opciones-grid/mas-opciones-grid.component';
import {ClsUtil} from '../../../util/cls-util';
import {AppPresupuestosService} from '../../../core/services/app-presupuestos.service';
import {ClsObjCrudCatalogos} from '../../../clases-pu/02-catalogos/cls-obj-crud-catalogos';
import {EnumMasOpciones} from '../../../core/models/enum/enum-mas-opciones';
import {INeodataGridCell, INeodataMenu} from '../../../core/models/interfaces/generico-interface';
import {EnumMCGenerales} from '../../../core/models/enum/enum-menu-contextual';
import {TresPuntosComponent} from '../../util/controles/tres-puntos/tres-puntos.component';
import {EnumNombresGrids} from '../../../core/models/enum/enum-nombres-grids';
import {ClsObjConfiguracionGrid} from '../../../clases-pu/util/cls-obj-configuracion-grid';
import {ClsObjGenerico} from '../../../clases-pu/util/cls-obj-generico';
import {EnumTresPuntos} from '../../../core/models/enum/enum-tres-puntos';
import {ClsObjCopiado} from '../../../clases-pu/01-presupuesto/copiado/cls-obj-copiado';
import {VtnGenericaComponent} from '../../util/ventanas/vtn-generica/vtn-generica.component';
import {DetallePegadoComponent} from '../../util/ventanas/detalle-pegado/detalle-pegado.component';
import {FiltroGeneralModernoComponent} from '../../util/controles/filtro-general-moderno/filtro-general-moderno.component';
import {ClsObjPegado} from '../../../clases-pu/99-herramientas/pegado/cls-obj-pegado';
import {TranslateModule} from '@ngx-translate/core';
import {ContextMenuGenericoComponent} from '../../util/controles/context-menu-generico/context-menu-generico.component';
import {UppercaseDirective} from '../../../core/directivas/uppercase.directive';
import {FormsModule} from '@angular/forms';
import {PasteHandlerNeodataDirective} from '../../../core/directivas/paste-handler-neodata.directive';
import {ClsCiudades, ClsClientes} from 'src/app/core/models/cls-catalogos';
import {ClsColDetallePegado} from 'src/app/core/models/cls-pegado';
import {TipoMensajesService} from "../../../core/services/tipo-mensajes.service";
import {SummaryPipeNeoPipe} from "../../../core/pipes/summary-pipe-neo.pipe";
import {CrearComponenteDinamicoService} from "../../../core/services/crear-componente-dinamico.service";

@Component({
  selector: 'app-clientes',
  templateUrl: './clientes.component.html',
  styleUrls: ['./clientes.component.scss'],
  imports: [
    IgxGridModule,
    IGX_GRID_DIRECTIVES,
    TranslateModule,
    FiltroGeneralModernoComponent,
    IgxIconComponent,
    MasOpcionesGridComponent,
    PasteHandlerNeodataDirective,
    IGX_INPUT_GROUP_DIRECTIVES,
    FormsModule,
    UppercaseDirective,
    IgxFocusDirective,
    IgxTextSelectionDirective,
    IgxActionStripModule,
    IGX_ACTION_STRIP_DIRECTIVES,
    IgxButtonModule,
    IgxButtonDirective,
    ContextMenuGenericoComponent,
    IgxRippleModule,
    IgxRippleDirective,
    SummaryPipeNeoPipe,
    IgxInputGroupComponent,
    IgxSuffixDirective
  ],
  providers: [SummaryPipeNeoPipe]
})
export class ClientesComponent extends ClsConfig implements OnInit, AfterViewInit {
  private infPpto = inject(AppPresupuestosService);
  private tipoMsg = inject(TipoMensajesService);
  private summaryPipe = inject(SummaryPipeNeoPipe);
  private excelExportService = inject(IgxExcelExporterService);
  private pdfExportService = inject(IgxPdfExporterService);
  private crearCompDinamico = inject(CrearComponenteDinamicoService);

  @ViewChild('gridClientes', {read: IgxGridComponent, static: true})
  public gridClientes: IgxGridComponent;
  @ViewChild('masOpcionesG', {read: MasOpcionesGridComponent, static: true})
  public masOpcionesG: MasOpcionesGridComponent;

  @ViewChild('filtroGeneral', {read: FiltroGeneralModernoComponent, static: true})
  public filtroGeneral: FiltroGeneralModernoComponent;
  @Input()
  public modoEdicion = true;
  // ajuste de texto
  @HostBinding('class') public themesClass = 'noAjustarTexto';
  public clicked = false;

  public tresPuntosCCcliente: TresPuntosComponent;
  public tresPuntosCiudad: TresPuntosComponent;

  public errorAlCargar: boolean;
  public dataClientes: ClsClientes[] = [];
  public activarBotones = false;
  // mostrar actionStrip
  public showActionStrip = true;
  // clase catalogos
  public mObjCRUDCatalogos: ClsObjCrudCatalogos = new ClsObjCrudCatalogos();
  private mObjGenerico: ClsObjGenerico = new ClsObjGenerico();
  private mObjCopiado: ClsObjCopiado = new ClsObjCopiado();
  private mObjPegado: ClsObjPegado = new ClsObjPegado();
  // menucontextual
  public verContextMenu = false;
  public contextmenuX = 0;
  public contextmenuY = 0;
  public cellMenuContextaul: IgxGridCell;
  public menus: INeodataMenu[] = [];
  public lengthMenu: number;
  public subMenusOpciones: any[];
  public sizeMenu = '';
  // CONFIGGRIDS: definir cada ng-Template que tengamos en el HTML
  @ViewChild('clienteHeaderTemplate', {static: true}) public clienteHeaderTemplate: TemplateRef<any>;
  @ViewChild('clienteEditorTemplate', {static: true}) public clienteEditorTemplate: TemplateRef<any>;
  @ViewChild('nombreClienteHeaderTemplate', {static: true}) public nombreClienteHeaderTemplate: TemplateRef<any>;
  @ViewChild('nombreClienteEditorTemplate', {static: true}) public nombreClienteEditorTemplate: TemplateRef<any>;
  @ViewChild('direccionClienteEditorTemplate', {static: true}) public direccionClienteEditorTemplate: TemplateRef<any>;
  @ViewChild('coloniaClienteHeaderTemplate', {static: true}) public coloniaClienteHeaderTemplate: TemplateRef<any>;
  @ViewChild('coloniaClienteEditorTemplate', {static: true}) public coloniaClienteEditorTemplate: TemplateRef<any>;
  @ViewChild('descripcionCiudadClienteHeaderTemplate', {static: true}) public descripcionCiudadClienteHeaderTemplate: TemplateRef<any>;
  @ViewChild('desCiudadClienteEditorTemplate', {static: true}) public desCiudadClienteEditorTemplate: TemplateRef<any>;
  @ViewChild('cpEditorTemplate', {static: true}) public cpEditorTemplate: TemplateRef<any>;
  @ViewChild('telefonoClienteEditorTemplate', {static: true}) public telefonoClienteEditorTemplate: TemplateRef<any>;
  @ViewChild('mailClienteEditorTemplate', {static: true}) public mailClienteEditorTemplate: TemplateRef<any>;
  @ViewChild(IgxGridStateDirective, {static: true}) public state;
  // Grid Layout
  public mObjConfigGrids: ClsObjConfiguracionGrid = new ClsObjConfiguracionGrid();
  // ConfigGridLayout
  public optionsGridLocal = {
    cellSelection: true,
    rowSelection: false,
    filtering: false,
    advancedFiltering: true,
    paging: true,
    sorting: false,
    groupBy: true,
    columns: true,
    expansion: true,
    rowPinning: false,
    columnSelection: true
  };
  public vtnGenerico: VtnGenericaComponent;

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.gridClientes.data = [];
  }

  public ngAfterViewInit() {
    // se genera la plantilla default del grid
    const stateDefault = this.state.getState(true);

    this.mObjConfigGrids.saveGridState(EnumNombresGrids.Clientes, true, stateDefault, '', this.clicked);
    const state = this.mObjConfigGrids.initGridState(EnumNombresGrids.Clientes);
    if (!ClsUtil.esNulo(state[0])) {
      this.state.setState(state[0]);
    }
    this.clicked = state[1];
    const result: { themesClass: string, clicked: boolean } = ClsUtil.ajustarTexto(this.clicked);
    this.themesClass = result.themesClass;
    this.clicked = result.clicked;
  }

  public onColumnInit(column: IgxColumnComponent) {
    switch (column.field) {
      case 'Cliente':
        column.headerTemplate = this.clienteHeaderTemplate;
        column.inlineEditorTemplate = this.clienteEditorTemplate;
        column.summaries = this.summaryPipe.transform('filasSummary');
        break;
      case 'NombreCliente':
        column.headerTemplate = this.nombreClienteHeaderTemplate;
        column.inlineEditorTemplate = this.nombreClienteEditorTemplate;
        break;
      case 'DireccionCliente':
        column.inlineEditorTemplate = this.direccionClienteEditorTemplate;
        break;
      case 'ColoniaCliente':
        column.headerTemplate = this.coloniaClienteHeaderTemplate;
        column.inlineEditorTemplate = this.coloniaClienteEditorTemplate;
        break;
      case 'DescripcionCiudadCliente':
        column.headerTemplate = this.descripcionCiudadClienteHeaderTemplate;
        column.inlineEditorTemplate = this.desCiudadClienteEditorTemplate;
        break;
      case 'CodigoPostalCliente':
        column.inlineEditorTemplate = this.cpEditorTemplate;
        break;
      case 'TelefonoCliente':
        column.inlineEditorTemplate = this.telefonoClienteEditorTemplate;
        break;
      case 'MailCliente':
        column.inlineEditorTemplate = this.mailClienteEditorTemplate;
        break;
    }
  }

  public async cargarClientes() {
    if (!ClsUtil.esNulo(this.infPpto.organizacion)) {
      try {
        this.tipoMsg.mostrarWaitDialog('MENSAJES.WAIT.GET_CATALOGOS');
        this.mObjCRUDCatalogos.dataCatalogo = [];
        this.dataClientes = [];
        await this.mObjCRUDCatalogos.obtenerCatalogo(0, 'ConsultarClientes2021');
        this.mObjCRUDCatalogos.dataCatalogo.forEach(item => {
          const cli: ClsClientes = {
            IdCliente: item.IdCliente,
            Cliente: item.Cliente,
            NombreCliente: item.NombreCliente,
            DireccionCliente: item.DireccionCliente,
            ColoniaCliente: item.ColoniaCliente,
            IdCiudadCliente: item.IdCiudadCliente,
            DescripcionCiudadCliente: item.Ciudad.Ciudad,
            CodigoPostalCliente: item.CodigoPostalCliente,
            TelefonoCliente: item.TelefonoCliente,
            MailCliente: item.MailCliente,
          };
          this.dataClientes.push(cli);
        });
        this.gridClientes.data = this.dataClientes;
        this.errorAlCargar = false;
        this.tipoMsg.cerrarWaitDialog();
      } catch (e) {
        this.tipoMsg.cerrarWaitDialog();
        this.errorAlCargar = true;
        this.tipoMsg.mostrarMsg(e.message, 'error');
      }
    }
  }

  public menuContextual(evt: any) {
    evt.event.preventDefault();
    this.disableContextMenu();
    this.disableAllContextMenu();
    this.menus = this.mObjCRUDCatalogos.crearMenuContextual({
      esCliente: true,
      esUnidad: false,
      esEmpresa: false
    }, this.infPpto.esPptoMaestro);
    this.subMenusOpciones = [];
    this.lengthMenu = this.menus.filter(x => !x.disabled).length;
    this.contextmenuX = ClsUtil.calcPosition(document.body.clientWidth, evt.event.clientX, true, this.lengthMenu);
    this.contextmenuY = ClsUtil.calcPosition(document.body.clientHeight, evt.event.clientY, false, this.lengthMenu);
    this.sizeMenu = (this.lengthMenu * 37) + 'px';
    this.cellMenuContextaul = evt.cell;
    this.verContextMenu = true;
  }

  public disableContextMenu() {
    if (this.verContextMenu) {
      this.verContextMenu = false;
    }
  }

  public disableAllContextMenu() {
    this.mObjGenerico.disableAllContextMenu(this.infPpto);
  }

  public async accionSeleccionada(evt: INeodataGridCell) {
    try {
      switch (evt.accionMenu.id) {
        case EnumMCGenerales.ContactoCliente:
          this.tresPuntosCCcliente = this.crearCompDinamico.crearComponente(TresPuntosComponent).instance as TresPuntosComponent;
          this.tresPuntosCCcliente.tipoCatalogo = EnumTresPuntos.ContactoCliente;
          this.tresPuntosCCcliente.dataClientes = evt.dataSelected.row.data;
          await this.tresPuntosCCcliente.onOpen();
          break;
        case EnumMCGenerales.Copiar:
          await this.copiarData();
          break;
        case EnumMCGenerales.Pegar:
          let data: any = await navigator.clipboard.readText().then((data2) => data2);
          data = this.pasteHandlerNeo.processData(data);
          await this.datosPegadosDesdeExcel(data);
          break;
        case EnumMasOpciones.Ajustar:
          const result: { themesClass: string, clicked: boolean } = ClsUtil.ajustarTexto(this.clicked);
          this.themesClass = result.themesClass;
          this.clicked = result.clicked;
          break;
        case EnumMCGenerales.GuardarLayout:
          const state = this.state.getState(true);
          this.mObjConfigGrids.saveGridState(EnumNombresGrids.Clientes, false, '', state, !this.clicked);
          break;
        case EnumMCGenerales.ReestablecerLayout:
          this.restoreGrid();
          break;
      }
    } catch (e) {
      this.tipoMsg.mostrarMsg(e.message, 'error');
    }
  }

  public restoreGrid() {
    const stateDefault = this.mObjConfigGrids.restoreGrid(EnumNombresGrids.Clientes);
    if (!ClsUtil.esNulo(stateDefault[0])) {
      this.state.setState(stateDefault[0]);
    }
    this.clicked = stateDefault[1];
    const result: { themesClass: string, clicked: boolean } = ClsUtil.ajustarTexto(this.clicked);
    this.themesClass = result.themesClass;
    this.clicked = result.clicked;
  }

  public clearInput() {
    this.filtroGeneral.input.value = '';
    this.gridClientes.clearFilter();
  }

  public filterInput(filtro: string) {
    this.gridClientes.filteringLogic = FilteringLogic.Or;
    this.gridClientes.filterGlobal(filtro, IgxStringFilteringOperand.instance().condition('contains'));
  }

  public rowEditEnter() {
    this.showActionStrip = false;
  }

  public rowEditExit() {
    this.showActionStrip = true;
  }

  // evento que se ocupa para guardar o modificar
  public async addUpdateCliente(cliente: IGridEditDoneEventArgs) {
    const newValor: ClsClientes = cliente.newValue;
    const oldValor: ClsClientes = cliente.oldValue;
    if (!ClsUtil.esNulo(this.tresPuntosCiudad)) {
      newValor.IdCiudadCliente = this.tresPuntosCiudad.idDefault;
      newValor.DescripcionCiudadCliente = this.tresPuntosCiudad.valorDefault;
    }
    if (cliente.isAddRow) {
      await this.agregarModificarCliente(newValor, oldValor, cliente.isAddRow);
    } else {
      // al editar los campos, validar que sean distintos para ocupar el servicio
      if (this.mObjCRUDCatalogos.validarSiCambioCamposCatalogos(newValor, oldValor, EnumTresPuntos.Clientes)) {
        await this.agregarModificarCliente(newValor, oldValor, cliente.isAddRow);
      }
    }
  }

  private async agregarModificarCliente(newCliente: ClsClientes, oldCliente: ClsClientes, isAddRow: boolean) {
    let respuesta: bigint;
    const objCatalogo: ClsClientes = new ClsClientes();
    try {
      objCatalogo.IdCliente = isAddRow ? ClsUtil.parseJSONBig(0) : newCliente.IdCliente;
      objCatalogo.Cliente = newCliente.Cliente.toUpperCase();
      objCatalogo.NombreCliente = newCliente.NombreCliente;
      objCatalogo.DireccionCliente = ClsUtil.esNulo(newCliente.DireccionCliente) ? '' : newCliente.DireccionCliente;
      objCatalogo.ColoniaCliente = ClsUtil.esNulo(newCliente.ColoniaCliente) ? '' : newCliente.ColoniaCliente;
      objCatalogo.IdCiudadCliente = ClsUtil.esNulo(newCliente.IdCiudadCliente) ? BigInt('0') : newCliente.IdCiudadCliente;
      objCatalogo.CodigoPostalCliente = ClsUtil.esNulo(newCliente.CodigoPostalCliente) ? '' : newCliente.CodigoPostalCliente;
      objCatalogo.TelefonoCliente = ClsUtil.esNulo(newCliente.TelefonoCliente) ? '' : newCliente.TelefonoCliente;
      objCatalogo.MailCliente = ClsUtil.esNulo(newCliente.MailCliente) ? '' : newCliente.MailCliente;
      this.tipoMsg.mostrarWaitDialog(isAddRow ? 'MENSAJES.WAIT.GUARDANDO_CATALOGO' : 'MENSAJES.WAIT.MODIFICANDO_CATALOGO');
      respuesta = await this.mObjCRUDCatalogos.agregarModificarCatalogo([objCatalogo], 'ClientesRegistraActualiza2021');
      if (isAddRow) {
        newCliente.IdCliente = respuesta;
      }
      this.tipoMsg.mostrarToast(isAddRow ? 'MENSAJES.TOAS.GUARDANDO_CATALOGO' : 'MENSAJES.TOAS.MODIFICANDO_CATALOGO');
      this.tresPuntosCiudad = undefined;
      this.tipoMsg.cerrarWaitDialog();
    } catch (e) {
      this.tipoMsg.cerrarWaitDialog();
      this.cancelarAddUpdateClientes(newCliente, oldCliente, isAddRow);
      this.tipoMsg.mostrarMsg(e.message, 'error');
    }
  }

  // se ocupa cuando manda error al intentar agregar o modificar,
  // al agregar si manda error se quita la fila del grid
  // al editar si manda error se regresa a los valores anteriores
  private cancelarAddUpdateClientes(newCliente: ClsClientes, oldCliente: ClsClientes, isAddRow: boolean) {
    if (isAddRow) {
      this.gridClientes.deleteRowById(newCliente.IdCliente);
    } else {
      this.gridClientes.updateRow(oldCliente, oldCliente.IdCliente);
    }
    this.tresPuntosCiudad = undefined;
  }

  private async eliminarClientes(rowContext: RowType) {
    const cliente: ClsClientes = rowContext.data;
    try {
      this.tipoMsg.mostrarWaitDialog('MENSAJES.WAIT.ELIMINANDO_CATALOGO', undefined, 'delete');
      await this.mObjCRUDCatalogos.eliminarCatalogo(cliente.IdCliente, 'EliminarClientes2021');
      this.gridClientes.getRowByIndex(rowContext.index).delete();
      this.tipoMsg.mostrarToast('MENSAJES.TOAS.ELIMINANDO_CATALOGO');
      this.tipoMsg.cerrarWaitDialog();
    } catch (e) {
      this.tipoMsg.cerrarWaitDialog();
      this.tipoMsg.mostrarMsg(e.message, 'error');
    }
  }

  // se ocupa el evento rowEdit para validar uno o varios campos obligatorios,
  // si falta algun campo de todo la fila se cancela la edicio y se manda mensaje que campos faltan
  // en caso de ser todo OK, procede al agregado o modificado
  public validarCliente(cliente: IGridEditEventArgs) {
    const valor: ClsClientes = cliente.newValue;
    cliente.cancel = this.esValido(valor, cliente, cliente.isAddRow);
  }

  // en este caso se pasa el valor de la cliente, ya que es el unico campo obligatorio,
  // en caso de ser mas campos a validar, pasar toda la clase
  private esValido(cliente: ClsClientes, cli: any, isAddRow: boolean): boolean {
    // validar campos obligatorios
    if (ClsUtil.esNulo(cliente.Cliente)) {
      this.tipoMsg.mostrarMsg(this.mObjGenerico.getTranslationsAlertValidarCampos(this.mObjGenerico.getTranslationValidarColuma('GRIDS.CLIENTE.COL_CLIENTE')));
      return true;
    }
    if (ClsUtil.esNulo(cliente.NombreCliente)) {
      this.tipoMsg.mostrarMsg(this.mObjGenerico.getTranslationsAlertValidarCampos(this.mObjGenerico.getTranslationValidarColuma('GRIDS.CLIENTE.COL_NOMBRE')));
      return true;
    }
    // if (ClsUtil.esNulo(cliente.ColoniaCliente)) {
    //   this.tipoMsg.mostrarMsg(this.mObjGenerico.getTranslationsAlertValidarCampos(this.mObjGenerico.getTranslationValidarColuma('GRIDS.CLIENTE.COL_COLONIA')));
    //   return true;
    // }
    // if (ClsUtil.esNulo(cliente.DescripcionCiudadCliente)) {
    //   this.tipoMsg.mostrarMsg(this.mObjGenerico.getTranslationsAlertValidarCampos(this.mObjGenerico.getTranslationValidarColuma('GRIDS.CLIENTE.COL_CIUDAD')));
    //   return true;
    // }
    // valida si ya existe la empresa cuando se agrega o modifica
    if (isAddRow) {
      if (this.dataClientes.findIndex(cliente2 => cliente2.Cliente === cliente.Cliente) !== -1) {
        this.tipoMsg.mostrarMsg(this.mObjGenerico.getTranslationsAlertRegistroExistente(cliente.Cliente));
        return true;
      }
    } else {
      if (cliente.Cliente !== cli.oldValue.Cliente) {
        if (this.dataClientes.findIndex(cliente2 => cliente2.Cliente === cliente.Cliente) !== -1) {
          this.tipoMsg.mostrarMsg(this.mObjGenerico.getTranslationsAlertRegistroExistente(cliente.Cliente));
          return true;
        }
      }
    }
    return false;
  }

  public async customKeydown(eventArgs: any) {
    const ctrl = eventArgs.ctrlKey;
    const key = eventArgs.keyCode;
    // Ctrl-C ||  Cmd-C
    if ((ctrl || eventArgs.metaKey) && key === 67) {
      await this.copiarData();
    }
  }

  public accionStripRowBtn(rowContext: RowType, indexBtn: number) {
    try {
      switch (indexBtn) {
        case 1:
          this.beginAddRowByIndexNeo(this.gridClientes, rowContext.index);
          break;
        case 2:
          this.tipoMsg.mostrarQuestion(async (resp: boolean) => {
            if (resp) {
              await this.eliminarClientes(rowContext);
            }
          }, this.mObjGenerico.getTranslationsQuestionBorrar(rowContext.data.Cliente));
          break;
      }
    } catch (e) {
      this.tipoMsg.mostrarMsg(e.message, 'error');
    }
  }

  public async onSelectionDropDown(opcion: string) {
    try {
      switch (opcion) {
        case EnumMasOpciones.Ajustar:
          const result: { themesClass: string, clicked: boolean } = ClsUtil.ajustarTexto(this.clicked);
          this.themesClass = result.themesClass;
          this.clicked = result.clicked;
          break;
        case EnumMasOpciones.ExportarExcel:
          const sms = await ClsUtil.exportarDatos(this.gridClientes, this.mObjGenerico.getTranslationsGetCatalogos('MENSAJES.GRALS.CLIENTES'), this.excelExportService).then(sms => { return sms });
          this.tipoMsg.mostrarToast(this.mObjGenerico.getTranslationsSmsExportar(sms, this.gridClientes.selectedRows.length));
          break;
        case EnumMasOpciones.ExportarPDF:
          await ClsUtil.abrirVentanaPersonalizarPDF(
            this.gridClientes,
            this.mObjGenerico.getTranslationsGetCatalogos('MENSAJES.GRALS.CLIENTES'),
            this.pdfExportService,
            this.crearCompDinamico,
            this.tipoMsg,
            this.mObjGenerico
          );
          break;
        case EnumMasOpciones.Actualizar:
          await this.cargarClientes();
          break;
        case EnumMasOpciones.LimpiarFiltroColumnas:
          this.clearInput();
          break;
      }
    } catch (e) {
      this.tipoMsg.mostrarMsg(e.message, 'error');
    }
  }

  public async onOpen(input: HTMLInputElement, data: ClsClientes) {
    const selectRows: any = [this.tresPuntosCiudad?.idDefault];
    this.tresPuntosCiudad = this.crearCompDinamico.crearComponente(TresPuntosComponent).instance as TresPuntosComponent;
    this.tresPuntosCiudad.tipoCatalogo = EnumTresPuntos.Ciudades;
    this.tresPuntosCiudad.selectedRows = selectRows;
    await this.tresPuntosCiudad.onOpen();
    this.tresPuntosCiudad.eventFilaSeleccionada.subscribe((valor: ClsCiudades) => {
      const ciudad: string = valor.Ciudad.toUpperCase();
      input.value = ciudad;
      this.gridClientes.updateCell(ciudad, data.IdCliente, 'DescripcionCiudadCliente');
      setTimeout(() => {
        input.focus();
      }, 5);
    });
  }

  public handleRowSelection() {
    this.gridClientes.nativeElement.focus();
  }

  public async datosPegadosDesdeExcel(datosPegado: any[]) {
    try {
      this.tipoMsg.mostrarWaitDialog('MENSAJES.WAIT.PEGANDO');
      let arrayClientes: ClsClientes[] = [];
      let dataDetalle: ClsColDetallePegado[];
      const colCli: string = this.mObjGenerico.getTranslationsSubject('GRIDS.CLIENTE.COL_CLIENTE');
      const colNom: string = this.mObjGenerico.getTranslationsSubject('GRIDS.CLIENTE.COL_NOMBRE');
      const colDir: string = this.mObjGenerico.getTranslationsSubject('GRIDS.CLIENTE.COL_DIRECCION');
      const colCol: string = this.mObjGenerico.getTranslationsSubject('GRIDS.CLIENTE.COL_COLONIA');
      const colCiu: string = this.mObjGenerico.getTranslationsSubject('GRIDS.CLIENTE.COL_CIUDAD');
      const colCp: string = this.mObjGenerico.getTranslationsSubject('GRIDS.CLIENTE.COL_CP');
      const colTel: string = this.mObjGenerico.getTranslationsSubject('GRIDS.CLIENTE.COL_TELEFONO');
      const colMail = 'Mail';
      this.mObjCopiado.columnasRequeridas = [colCli, colNom];
      if (this.mObjCopiado.validarCamposRequeridos(datosPegado)) {
        let datos = this.mObjCopiado.procesarDatos(datosPegado, true);
        datos = this.mObjPegado.mergeDescriptions(datos, EnumNombresGrids.Clientes);
        dataDetalle = this.mObjPegado.verificarDetallePegado(datos, [colCli, colNom, colDir, colCol, colCiu, colCp, colTel, colMail], [colCli, colNom], EnumNombresGrids.Clientes, this.mObjGenerico);
        if (dataDetalle.length > 0) {
          const vtnGenerico = this.crearCompDinamico.crearComponente(VtnGenericaComponent).instance as VtnGenericaComponent;
          vtnGenerico.queVtnEstaAbierta = 'PegadoEspecial';
          const vtnDiferencia = vtnGenerico.crearComponente(DetallePegadoComponent);
          vtnDiferencia.dataDetalle = dataDetalle;
          vtnDiferencia.open();
        } else {
          datos.forEach(x => {
            const valCli: string = (x[colCli] as string).toUpperCase();
            const valNom: string = ClsUtil.cadenaX(x[colNom] as string);
            const valDir: string = ClsUtil.cadenaX(x[colDir] as string);
            const valCol: string = ClsUtil.cadenaX(x[colCol] as string);
            const valCiu: string = (x[colCiu] as string).toUpperCase();
            const valCp: string = ClsUtil.cadenaX(x[colCp] as string);
            const valTel: string = ClsUtil.cadenaX(x[colTel] as string);
            const valMail: string = ClsUtil.cadenaX(x[colMail] as string);
            const resp: any = this.mObjCRUDCatalogos.crearObjCatalogos(this.dataClientes, [valCli, valNom, valDir, valCol, valCiu, valCp, valTel, valMail], [colCli, colNom, colDir, colCol, colCiu, colCp, colTel, colMail], EnumTresPuntos.Clientes, this.mObjGenerico);
            if (!ClsUtil.esNulo(resp.esNuevo)) {
              if (resp.esNuevo) {
                arrayClientes.push(resp.obj);
              } else {
                this.gridClientes.updateCell(valCli, resp.obj.IdCliente, 'Cliente');
                this.gridClientes.updateCell(valNom, resp.obj.IdCliente, 'NombreCliente');
                this.gridClientes.updateCell(valDir, resp.obj.IdCliente, 'DireccionCliente');
                this.gridClientes.updateCell(valCol, resp.obj.IdCliente, 'ColoniaCliente');
                this.gridClientes.updateCell(valCiu, resp.obj.IdCliente, 'DescripcionCiudadCliente');
                this.gridClientes.updateCell(valCp, resp.obj.IdCliente, 'CodigoPostalCliente');
                this.gridClientes.updateCell(valTel, resp.obj.IdCliente, 'TelefonoCliente');
                this.gridClientes.updateCell(valMail, resp.obj.IdCliente, 'MailCliente');
                arrayClientes.push(resp.obj);
              }
            }
          });
          // invocar servicio para agregar o modificar siempre y cuando el arrayUnidades tenga valor
          if (arrayClientes.length > 0) {
            const respuesta: any = await this.mObjCRUDCatalogos.agregarModificarCatalogo(arrayClientes, 'ClientesRegistraActualizaCod', false);
            // filtro los registros con id 0
            arrayClientes = arrayClientes.filter(value => value.IdCliente === BigInt(0));
            // iteramos la respuesta para ir asignando los ids para los registros nuevos
            const key: string[] = Object.keys(respuesta);
            key.forEach(x => {
              const cli: ClsClientes = arrayClientes.find(value1 => value1.Cliente === x);
              if (!ClsUtil.esNulo(cli)) {
                cli.IdCliente = ClsUtil.bigintX(respuesta[x]);
                this.gridClientes.addRow(cli);
              }
            });
            this.tipoMsg.mostrarToast(this.mObjGenerico.getTranslationsSubject('MENSAJES.TOAS.REGISTROS_PEGADOS').replace('{0}', arrayClientes.length.toString()));
          }
        }
      }
    } catch (e) {
      this.tipoMsg.mostrarMsg(e.message);
    } finally {
      this.tipoMsg.cerrarWaitDialog();
    }
  }

  public async copiarData() {
    try {
      this.tipoMsg.mostrarWaitDialog('MENSAJES.WAIT.COPIANDO');
      const msg: string = await ClsUtil.copiarDatosGrids(this.gridClientes, 'IdCliente', this.mObjGenerico);
      msg && this.tipoMsg.mostrarToast(msg);
    } catch (e) {
      throw new Error(e.message);
    } finally {
      this.tipoMsg.cerrarWaitDialog();
    }
  }

  public clearProps() {
    this.gridClientes.clearSort();
    this.gridClientes.clearFilter();
    this.gridClientes.clearSearch();
    this.gridClientes.deselectAllRows();
    this.clearInput();
  }

  public registroSeleccionado() {
    const rowSeleccionados: bigint[] = this.gridClientes.selectedRows;
    try {
      if (rowSeleccionados.length === 0) {
        throw new Error('MENSAJES.ALERT.SELECCIONAR_REGISTRO');
      }
      const rowData = this.gridClientes.getRowData(rowSeleccionados[0]);
      this.gridClientes.doubleClick.emit(rowData);
    } catch (e) {
      this.tipoMsg.mostrarMsg(e.message, 'error');
    }
  }
}
